import styled from '@emotion/styled';

export const AddButtonDiv = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 17px;
  margin-top: -2.5rem;
`;

export const AddCMSButtonDiv = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 17px;
  margin-top: -3.3rem;
`;
